import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'pinnakl-modal',
  templateUrl: './pinnakl-modal.component.html',
  imports: [DialogModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./pinnakl-modal.component.scss'],
})
export class PinnaklModalComponent {
  readonly height = input<number | string>(undefined);
  readonly width = input<number | string>(undefined);
  readonly minWidth = input<number | string>(undefined);
  readonly maxHeight = input<number | string>(undefined);
  readonly hideDialog = input(true);
  readonly showCloseButton = input(true);
  readonly title = input<string>(undefined);
  readonly className = input<string>(undefined);
  readonly draggable = input(false);
  readonly closeModal = output();

  readonly dialogStyle = computed(() => ({
    ...(this.width() != null ? { width: typeof this.width() === 'number' ? `${this.width()}px` : this.width() } : {}),
    ...(this.height() != null
      ? { height: typeof this.height() === 'number' ? `${this.height()}px` : this.height() }
      : {}),
    ...(this.minWidth() != null
      ? { 'min-width': typeof this.minWidth() === 'number' ? `${this.minWidth()}px` : this.minWidth() }
      : {}),
    ...(this.maxHeight() != null
      ? { 'max-height': typeof this.maxHeight() === 'number' ? `${this.maxHeight()}px` : this.maxHeight() }
      : {}),
  }));

  closeModalEmit(): void {
    this.closeModal.emit(undefined);
  }
}
